import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { typography } from 'src/theme/typography';

const cardTitle = css`
    font-size: 20px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.03em;
`;

const CartWrapStyle = styled('div')`
    ${typography.bodyXs}

    .itemCart {
        margin-bottom: 16px;
    }
    .viewPayment {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        ${cardTitle}
        .name {
            span {
                font-weight: 400;
            }
        }
        .iconPlus {
            cursor: pointer;
        }
    }

    .group {
        padding: 10px 16px;

        .detail {
            display: flex;
            align-items: flex-start;
            gap: 5px;
            padding: 5px 0;

            color: var(--sand-600);

            .iconDetail {
                color: var(--orange-300);
                margin-top: 1px;
            }

            .titleDetail {
                width: 90%;
                padding-left: 5px;
            }
        }
    }

    .box-total {
        border-top: 1px solid var(--sand-400);
        padding-top: 16px;
        margin-top: 16px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 7px 0;
            ${typography.bodyL}
            &.total {
                ${cardTitle}
            }
            &.savings {
                ${typography.bodyMd}
                color: var(--sand-600);
            }
        }
    }

    .extra-yards {
        .sub-title {
            font-weight: 700;
            font-size: 20px;
            margin-bottom: 6px;
        }
        .item {
            padding: 3px;
        }
        .icon-ex {
            color: var(--orange-300);
        }
    }

    .tee-times {
        border-radius: 6px;
        background: var(--blue-100);
        padding: 16px;
        margin-bottom: 24px;

        .sub-title {
            ${typography.bodyMd}
            margin-bottom: 3px;
        }
        .item {
            padding: 5px;
        }
    }

    &.mini-cart {
        .viewPayment {
            ${typography.bodyL}
        }
        .extra-yards {
            .sub-title {
                font-size: 18px;
            }
        }
        .box-total .item {
            ${typography.bodyMd}
            &.total {
                ${typography.bodyXl}
            }
            &.savings {
                ${typography.bodyXs}
                .value {
                    ${typography.bodySm}
                }
            }
        }
    }

    @media screen and (min-width: 768px) {
        .group {
            padding-left: 48px;
            padding-right: 48px;
        }

        &.mini-cart {
            .group {
                padding-left: 16px;
                padding-right: 16px;
            }
        }
    }
`;

export default CartWrapStyle;
